import React from 'react';
import { networkZones } from '../../../data/beheer/system';
import type { NetworkZone } from '../../../types/beheer';
const INTERNET: Record<NetworkZone['internet'], {
  label: string;
  tone: string;
}> = {
  ja: {
    label: 'Internet',
    tone: 'text-ink-soft'
  },
  beperkt: {
    label: 'Beperkt',
    tone: 'text-accent'
  },
  nee: {
    label: 'Geen internet',
    tone: 'text-ink-muted'
  }
};
export function NetworkZones() {
  return <div className="no-scrollbar overflow-x-auto rounded-3xl border border-white/[0.07] bg-night-900" data-id="element-446" data-mp="1zeqt8csepzff">
      <table className="w-full min-w-[560px] text-left text-[14px]" data-id="element-447" data-mp="1ufw8h5avq0so">
        <thead data-id="element-448" data-mp="288luvaubl7qb">
          <tr className="border-b border-white/[0.06] text-[12px] text-ink-muted" data-id="element-449" data-mp="28710pmbx3qsz">
            <th scope="col" className="px-5 py-3 font-medium" data-id="element-450" data-mp="245z2n8tqlksl">Zone</th>
            <th scope="col" className="px-3 py-3 text-right font-medium" data-id="element-451" data-mp="248v0yy9hybhk">Apparaten</th>
            <th scope="col" className="px-3 py-3 font-medium" data-id="element-452" data-mp="2i45sc1oj8eh6">Naar buiten</th>
            <th scope="col" className="px-5 py-3 font-medium" data-id="element-453" data-mp="2d8qfnd29gomc">Bereikt intern</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-white/[0.05]" data-id="element-454" data-mp="1y7ca8ta1gsjq">
          {networkZones.map(z => <tr key={z.id} data-id="element-455" data-mp="234ulwrffxlvf">
              <th scope="row" className="px-5 py-3 font-normal" data-id="element-456" data-mp="283p5hvl8fegl">
                <span className="block font-medium text-ink" data-id="element-457" data-mp="282dzdp4bdumb">
                  {z.name} <span className="font-mono text-[12px] font-normal text-ink-muted" data-id="element-458" data-mp="2c6by3ypq93eu">VLAN {z.vlan}</span>
                </span>
                <span className="block text-[12px] text-ink-muted" data-id="element-459" data-mp="2h43r6w23yvkm">
                  <code className="font-mono" data-id="element-460" data-mp="2m2f116sel62u">{z.subnet}</code> · {z.note}
                </span>
              </th>
              <td className="px-3 py-3 text-right tabular-nums text-ink-soft" data-id="element-461" data-mp="2qvi01ufy97qf">{z.devices}</td>
              <td className={`whitespace-nowrap px-3 py-3 ${INTERNET[z.internet].tone}`} data-id="element-462" data-mp="2vrylggvrl7zt">{INTERNET[z.internet].label}</td>
              <td className="whitespace-nowrap px-5 py-3 text-ink-soft" data-id="element-463" data-mp="2zwog62eosgj5">{z.reaches}</td>
            </tr>)}
        </tbody>
      </table>
    </div>;
}